(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ao-discount-popup]';
  var STORAGE_PREFIX = 'aoDiscountPopup:v6:';
  var PENDING_KEY = STORAGE_PREFIX + 'pendingAt';
  var PENDING_SCROLL_KEY = STORAGE_PREFIX + 'pendingScrollY';
  var PENDING_TTL = 15 * 60 * 1000;

  function storageGet(store, key) {
    try { return store.getItem(key); } catch (error) { return null; }
  }
  function storageSet(store, key, value) {
    try { store.setItem(key, value); } catch (error) {}
  }
  function storageRemove(store, key) {
    try { store.removeItem(key); } catch (error) {}
  }

  function init(root) {
    if (!root || root.dataset.aoDiscountReady === 'true') return;
    root.dataset.aoDiscountReady = 'true';

    var sectionId = root.dataset.sectionId || 'global';
    var modal = root.querySelector('[data-ao-discount-modal]');
    var dialog = root.querySelector('[data-ao-discount-dialog]');
    var teaser = root.querySelector('[data-ao-discount-teaser]');
    var signupPanel = root.querySelector('[data-ao-discount-signup-panel]');
    var successPanel = root.querySelector('[data-ao-discount-success-panel]');
    var form = root.querySelector('form');
    var email = root.querySelector('[data-ao-discount-email]');
    var submitButton = root.querySelector('[data-ao-discount-submit]');
    var errorNode = root.querySelector('[data-ao-discount-error]');
    var backdrop = root.querySelector('.ao-discount__backdrop');
    var copyButton = root.querySelector('[data-ao-discount-copy]');
    var codeNode = root.querySelector('[data-ao-discount-code]');
    var copyStatus = root.querySelector('[data-ao-discount-copy-status]');
    var delay = Math.max(0, Number(root.dataset.delay) || 5000);
    var hideDays = Math.max(1, Number(root.dataset.hideDays) || 30);
    var designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    var previewMode = designMode || /(?:\?|&)preview_theme_id=/.test(window.location.search);
    var serverEl = root.querySelector('[data-ao-discount-server]');
    var serverState = {
      postedSuccessfully: Boolean(serverEl && serverEl.dataset.posted === 'true'),
      hasErrors: Boolean(serverEl && serverEl.dataset.errors === 'true')
    };

    if (!modal || !dialog || !teaser || !signupPanel || !successPanel) return;

    var keys = {
      converted: STORAGE_PREFIX + 'converted',
      dismissed: STORAGE_PREFIX + 'dismissed',
      teaserHiddenUntil: STORAGE_PREFIX + 'teaserHiddenUntil'
    };

    // Popup si pamätá, že ho návštevník zavrel. Pri testovaní sa tým dá
    // zabuchnúť na 30 dní, preto ?aodp=reset stav vyčistí.
    var resetRequested = /(?:\?|&)aodp=reset\b/.test(window.location.search);
    if (resetRequested) {
      storageRemove(window.localStorage, keys.converted);
      storageRemove(window.localStorage, keys.dismissed);
      storageRemove(window.localStorage, keys.teaserHiddenUntil);
      storageRemove(window.sessionStorage, PENDING_KEY);
      storageRemove(window.sessionStorage, PENDING_SCROLL_KEY);
    }

    var lastFocused = null;
    var autoTimer = null;
    var layoutTick = null;
    var modalViewportTick = null;
    /* V258: hľadala sa len lišta z produktovej stránky trička. Na stránke
       obrazu sa volá inak (.ao-purchase-bar), takže bublina so zľavou si
       sadla presne na ňu a prekryla cenu — hlásené z Instagramu. Berieme
       všetky lepiace lišty, ktoré na webe existujú. */
    var STICKY_SELECTOR = '[data-sticky-cart], .ao-purchase-bar, .ao-cart-cta-sticky, .vehicle-progress-sticky';
    var stickyBar = document.querySelector('[data-sticky-cart]');

    function syncModalViewport() {
      if (modal.hidden) return;
      var viewport = window.visualViewport;
      var top = viewport ? Math.max(0, Math.round(viewport.offsetTop)) : 0;
      var height = viewport ? Math.max(280, Math.round(viewport.height)) : window.innerHeight;
      root.style.setProperty('--aodp-modal-top', top + 'px');
      root.style.setProperty('--aodp-modal-height', height + 'px');
    }

    function requestModalViewportSync() {
      if (modalViewportTick) return;
      modalViewportTick = window.requestAnimationFrame(function () {
        modalViewportTick = null;
        syncModalViewport();
      });
    }

    function isConverted() {
      if (previewMode) return false;
      return storageGet(window.localStorage, keys.converted) === '1';
    }

    function teaserIsSuppressed() {
      if (previewMode) return false;
      var until = Number(storageGet(window.localStorage, keys.teaserHiddenUntil) || 0);
      return until > Date.now();
    }

    function showTeaser() {
      if (isConverted() || teaserIsSuppressed()) return;
      teaser.hidden = false;
      syncTeaserOffset();
    }

    function hideTeaser() {
      teaser.hidden = true;
    }

    function setPanel(name) {
      signupPanel.hidden = name !== 'signup';
      successPanel.hidden = name !== 'success';
    }

    function openPopup(panelName) {
      if (panelName !== 'success' && isConverted() && !designMode) return;
      if (autoTimer) window.clearTimeout(autoTimer);

      lastFocused = document.activeElement;
      hideTeaser();
      setPanel(panelName || 'intro');
      modal.hidden = false;
      document.documentElement.classList.add('ao-discount-open');
      document.body.classList.add('ao-discount-open');
      syncModalViewport();

      window.requestAnimationFrame(function () {
        if (document.activeElement === document.body || document.activeElement === document.documentElement) {
          dialog.focus({ preventScroll: true });
        }
      });
    }

    function closePopup(showSticky) {
      modal.hidden = true;
      document.documentElement.classList.remove('ao-discount-open');
      document.body.classList.remove('ao-discount-open');

      if (!isConverted() && showSticky !== false) {
        storageSet(window.localStorage, keys.dismissed, '1');
        showTeaser();
      } else {
        hideTeaser();
      }

      if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
        try { lastFocused.focus({ preventScroll: true }); } catch (error) { lastFocused.focus(); }
      }
    }

    function markConverted() {
      storageSet(window.localStorage, keys.converted, '1');
      storageRemove(window.localStorage, keys.dismissed);
      storageRemove(window.localStorage, keys.teaserHiddenUntil);
      storageRemove(window.sessionStorage, PENDING_KEY);
      hideTeaser();
    }

    function pendingIsFresh() {
      var pendingAt = Number(storageGet(window.sessionStorage, PENDING_KEY) || 0);
      return pendingAt > 0 && (Date.now() - pendingAt) < PENDING_TTL;
    }

    function hasPopupFormQuery(params) {
      if (params.get('form_type') !== 'customer') return false;
      var tags = params.get('contact[tags]') || '';
      return tags.indexOf('discount-popup') !== -1 || window.location.search.indexOf('discount-popup') !== -1;
    }

    function cleanupSubmissionUrl() {
      try {
        var url = new URL(window.location.href);
        ['customer_posted', 'form_type', 'utf8', 'contact[tags]', 'contact[email]', 'contact[accepts_marketing]', 'commit'].forEach(function (key) {
          url.searchParams.delete(key);
        });
        if (url.hash === '#contact_form') url.hash = '';
        window.history.replaceState({}, document.title, url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
      } catch (error) {}
    }

    function handleReturnFromShopify() {
      var params = new URLSearchParams(window.location.search);
      var pending = pendingIsFresh();
      var success = serverState.postedSuccessfully === true || params.get('customer_posted') === 'true';
      var popupFormQuery = hasPopupFormQuery(params);
      var hasErrors = Boolean(serverState.hasErrors);
      var returnScrollY = Number(storageGet(window.sessionStorage, PENDING_SCROLL_KEY) || 0);

      function restoreReturnPosition() {
        storageRemove(window.sessionStorage, PENDING_SCROLL_KEY);
        window.requestAnimationFrame(function () {
          window.scrollTo(0, returnScrollY);
          window.requestAnimationFrame(function () { window.scrollTo(0, returnScrollY); });
        });
      }

      if (pending && hasErrors) {
        window.__aoDiscountHandledReturn = true;
        restoreReturnPosition();
        openPopup('signup');
        return true;
      }

      if (pending) {
        window.__aoDiscountHandledReturn = true;
        restoreReturnPosition();
        markConverted();
        cleanupSubmissionUrl();
        openPopup('success');
        return true;
      }

      return false;
    }

    function syncTeaserOffset() {
      var base = window.matchMedia('(max-width: 640px)').matches ? 12 : 18;
      var extra = 0;

      document.querySelectorAll(STICKY_SELECTOR).forEach(function (bar) {
        if (!bar || bar.hidden) return;
        var style = window.getComputedStyle(bar);
        var rect = bar.getBoundingClientRect();
        var isVisible = style.display !== 'none' && style.visibility !== 'hidden'
          && rect.height > 0 && rect.width > (window.innerWidth * 0.45);
        /* Sticky aj fixed: obidve končia na spodku obrazovky a obidve by
           bublina prekryla. */
        var sitsAtBottom = (style.position === 'fixed' || style.position === 'sticky')
          && rect.bottom >= (window.innerHeight - 4);
        if (isVisible && sitsAtBottom) {
          extra = Math.max(extra, rect.height + 12);
        }
      });

      root.style.setProperty('--aodp-teaser-bottom', (base + extra) + 'px');
    }

    function requestLayoutSync() {
      if (layoutTick) return;
      layoutTick = window.requestAnimationFrame(function () {
        layoutTick = null;
        syncTeaserOffset();
      });
    }

    root.querySelectorAll('[data-ao-discount-open]').forEach(function (button) {
      button.addEventListener('click', function () { openPopup('signup'); });
    });

    root.querySelectorAll('[data-ao-discount-close]').forEach(function (button) {
      button.addEventListener('click', function () { closePopup(true); });
    });


    var successClose = root.querySelector('[data-ao-discount-success-close]');
    if (successClose) {
      successClose.addEventListener('click', function () { closePopup(false); });
    }

    if (copyButton && codeNode) {
      copyButton.addEventListener('click', function () {
        var code = (codeNode.textContent || '').trim();
        var copied = function () {
          copyButton.textContent = 'SKOPÍROVANÉ ✓';
          if (copyStatus) copyStatus.textContent = 'Kód ' + code + ' je skopírovaný.';
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(copied).catch(function () {
            fallbackCopy(code, copied);
          });
        } else {
          fallbackCopy(code, copied);
        }
      });
    }

    function fallbackCopy(value, done) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        if (document.execCommand('copy')) done();
      } catch (error) {}
      field.remove();
    }

    var teaserClose = root.querySelector('[data-ao-discount-teaser-close]');
    if (teaserClose) {
      teaserClose.addEventListener('click', function () {
        var until = Date.now() + hideDays * 24 * 60 * 60 * 1000;
        storageSet(window.localStorage, keys.teaserHiddenUntil, String(until));
        hideTeaser();
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }

        storageSet(window.sessionStorage, PENDING_KEY, String(Date.now()));
        storageSet(window.sessionStorage, PENDING_SCROLL_KEY, String(Math.max(0, Math.round(window.scrollY || 0))));
        storageSet(window.localStorage, keys.dismissed, '1');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'ODOSIELAM…';
        }
        if (errorNode) errorNode.hidden = true;
      });
    }

    // Samotná modálna vrstva prirodzene blokuje stránku. Nepoužívame globálne
    // capture handlery pre pointerdown/mousedown/click — na iOS zdvojovali
    // spracovanie dotyku a input často zareagoval až na ďalší pokus.
    if (backdrop) {
      backdrop.addEventListener('click', function () { closePopup(true); });
    }

    if (email) {
      email.addEventListener('focus', function () {
        requestModalViewportSync();
        window.setTimeout(function () {
          if (document.activeElement === email) {
            try { email.scrollIntoView({ block: 'center', behavior: 'auto' }); } catch (error) {}
          }
        }, 180);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup(!isConverted());
      }
    });

    if (window.AOViewport) window.AOViewport.onResize(requestLayoutSync);
    else window.addEventListener('resize', requestLayoutSync, { passive: true });
    window.addEventListener('scroll', requestLayoutSync, { passive: true });
    /* `visualViewport` sa pri štipkovom zoome ozýva desiatky ráz za sekundu.
       Poloha teasera od zoomu nezávisí, stačí posun stránky. */
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestModalViewportSync, { passive: true });
      window.visualViewport.addEventListener('scroll', requestLayoutSync, { passive: true });
      window.visualViewport.addEventListener('scroll', requestModalViewportSync, { passive: true });
    }
    /* Lišty sa objavujú a miznú pri scrollovaní — sledujeme všetky. */
    if (window.MutationObserver) {
      document.querySelectorAll(STICKY_SELECTOR).forEach(function (bar) {
        var mo2 = new MutationObserver(requestLayoutSync);
        mo2.observe(bar, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
      });
      window.addEventListener('scroll', requestLayoutSync, { passive: true });
      window.addEventListener('resize', requestLayoutSync, { passive: true });
    }
    if (stickyBar && window.MutationObserver) {
      var mo = new MutationObserver(requestLayoutSync);
      mo.observe(stickyBar, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    }
    requestLayoutSync();

    if (handleReturnFromShopify()) return;

    function startAutomaticPopup() {
      if (autoTimer) return;
      if (designMode || previewMode) {
        autoTimer = window.setTimeout(function () { openPopup('signup'); }, delay);
      } else if (isConverted()) {
        hideTeaser();
      } else {
        /* Neotváraj celostránkový modal automaticky počas navigácie alebo
           práce v konfigurátore. Po piatich sekundách zachytával klik práve
           v momente, keď zákazník otváral produkt/košík, a web vyzeral ako
           zamrznutý. Ponuka ostáva dostupná ako neblokujúci teaser. */
        showTeaser();
      }
    }

    /* V Instagram/Facebook in-app prehliadači môže consent API nabehnúť
       pomaly. Klubový popup preto čaká, kým zákazník vybaví cookie dialóg,
       namiesto toho, aby sa oba modály prekrývali. */
    if (!designMode && !previewMode && document.documentElement.dataset.aoConsentPending === 'true') {
      document.addEventListener('ao:consent-resolved', startAutomaticPopup, { once:true });
    } else {
      startAutomaticPopup();
    }

    document.addEventListener('shopify:section:select', function (event) {
      if (!event.detail || event.detail.sectionId !== sectionId) return;
      openPopup('signup');
    });
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
